module.exports = __webpack_public_path__ + "img/rjjf.67309999.png";